module.exports = __webpack_public_path__ + "img/symphony_538_coffee.751acd8c.jpg";